mutation DepartmentDelete($input: DepartmentDeleteInput!) {
  departmentDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
